import { render } from "./HomeLooks.vue?vue&type=template&id=72747e1e&scoped=true&ts=true"
import script from "./HomeLooks.vue?vue&type=script&lang=ts"
export * from "./HomeLooks.vue?vue&type=script&lang=ts"

import "./HomeLooks.vue?vue&type=style&index=0&id=72747e1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72747e1e"]])

export default __exports__